export const ROUTES = {
  notFound: {
    path: '/admin/404',
  },
  invalidToken: {
    path: "/admin/app/invalidtoken",
  },
  homeRedirect: {
    path: "/admin/homeRedirect",
  },
  registeration: {
    path: "/admin/app/registration",
  },
  resetPassword: {
    path: '/admin/app/reset-password',
  },
  dashboardRedirect: {
    path: "/admin/dashboardRedirect",
  },
  genericErrorPage: {
    path: 'genericerrorpage.html',
  },
  login: {
    path: '/admin/login',
  },
  forgotPasswordRedirect: {
    path: '/admin/redirect/forgotPasswordRedirect',
  },
  registerationRedirect : {
    path: '/admin/redirect/registrationPageRedirect',
  },
  newPasswordRedirect: {
    path: '/admin/redirect/newPasswordRedirect',
  },
  apiGroups: {
    path: '/admin/api-groups',
  },
  apiGroupsAdd: {
    path: '/admin/api-groups/add',
  },
  apiGroupsEdit: {
    path: '/admin/api-groups/details',
  },
  applicationsForApiGroup: {
    path: '/admin/console/applications#apiGroup',
  },
  apiPlans: {
    path: '/admin/apis/api-plans',
  },
  apiPlansAdd: {
    path: '/admin/apis/api-plans/add',
  },
  apiPlansEdit: {
    path: '/admin/apis/api-plans/details',
  },
  apiPlansEnable: {
    path: '/admin/apis/api-plans/enable',
  },
  authProvidersAdd: {
    path: '/admin/settings/application-settings/auth-providers/add',
  },
  authProvidersEdit: {
    path: '/admin/settings/application-settings/auth-providers/edit',
  },
  authProvidersList: {
    path: '/admin/settings/application-settings/auth-providers',
  },
  applicationKeySettings: {
    path: '/admin/settings/application-settings',
  },
  newPassword: {
    path: '/admin/app/new-password',
  },
  changePassword: {
    path: '/admin/app/change-password',
  },
  users: {
    path: '/admin/console/users',
  },
  adminHome: {
    path: '/admin',
  },
  userHome: {
    path: '/admin/app/dashboard',
  },
  apiList: {
    path: '/publish/apis',
  },
  apiPlansList: {
    path: '/admin/apis/api-plans',
  },
  applicationsList: {
    path: '/admin/console/applications',
  },
  apperance: {
    path: '/appearance',
  },
  apiGroupsList: {
    path: '/admin/api-groups',
  },
  gatewayBundlesList: {
    path: '/publish/gateway-bundles',
  },
  keyStoresList: {
    path: '/admin/key-stores',
  },
  orgsList: {
    path: '/admin/console/organizations',
  },
  templateCategoriesList: {
    path: '/admin/console/templatecategories',
  },
  productsList: {
    path: '/admin/products',
  },
  rateQuotasList: {
    path: '/admin/rate-quotas',
  },
  usersList: {
    path: '/admin/console/users',
  },
  proxiesList: {
    path: '/admin/api-proxy',
  },
  authList: {
    path: '/publish/settings/authentication',
  },
  eulasList: {
    path: '/publish/eulas',
  },
  customFieldsList: {
    path: '/publish/settings/custom-fields',
  },
  customPagesList: {
    path: '/admin/settings/custom-pages',
  },
}

// list of pages rendered which don't check user authentication
export const NO_AUTH_PAGES = [
  '/admin/app/home',
  ROUTES.registeration.path,
  '/admin/app/check-your-email',
  '/admin/saml/login/confirm',
  '/admin/app/account-setup-form',
  ROUTES.newPassword.path,
  ROUTES.changePassword.path,
  ROUTES.resetPassword.path,
  ROUTES.login.path,
];

// list of pages rendered which don't check user authentication and show header
export const NO_AUTH_NO_HEADER_PAGES = [
  ROUTES.registeration.path,
  '/admin/app/check-your-email',
  '/admin/saml/login/confirm',
  '/admin/app/account-setup-form',
  '/admin/app/change-password',
  ROUTES.newPassword.path,
  ROUTES.changePassword.path,
  ROUTES.resetPassword.path,
  ROUTES.login.path,
];
